import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import pl from './pl.json';
import pt from './pt.json';
import ru from './ru.json';
import nl from './nl.json';

export const translations = {
  de,
  en,
  es,
  fr,
  it,
  pl,
  pt,
  ru,
  nl,
};

export { useTranslations } from './useTranslations';
export { injectTranslations } from './injectTranslations';
export type { TranslationKey, TranslationsFunc } from './types';
